import React, { useState } from "react";
import { MessageSquareText } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import api, { formatApiError } from "../lib/api";

export const CellTextButton = ({ recordId, name, label = "Text", endpoint = "/cell/text", body, testid, onDone }) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (msg.trim().length < 2) return toast.error("Write a short message first");
    setBusy(true);
    try {
      await api.post(endpoint, { ...(body || { record_id: recordId }), message: msg.trim() });
      toast.success(`Text sent to ${name} — their number stays private`);
      setMsg(""); setOpen(false); onDone && onDone();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" data-testid={testid || `cell-text-${recordId}`} onClick={() => setOpen(true)} title={`Text ${name} through the app`}
        className="inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-semibold hover:bg-[#E3F1EC]" style={{ color: "var(--sj-primary)" }}>
        <MessageSquareText className="h-3.5 w-3.5" />{label && <span>{label}</span>}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="cell-text-dialog">
          <DialogHeader>
            <DialogTitle className="font-head text-xl flex items-center gap-2"><MessageSquareText className="h-5 w-5" style={{ color: "var(--sj-primary)" }} /> Text {name}</DialogTitle>
            <DialogDescription>Sent from the church's number, so your number and theirs stay private. Their reply comes back to the portal.</DialogDescription>
          </DialogHeader>
          <textarea data-testid="cell-text-input" value={msg} onChange={(e) => setMsg(e.target.value)} rows={4} maxLength={300} placeholder="e.g. Hi! Just checking you're okay for Thursday's cell meeting?"
            className="w-full rounded-lg border px-3 py-2 text-sm outline-none focus:border-[#0B5E4E]" style={{ borderColor: "var(--sj-border)" }} />
          <p className="text-xs -mt-2" style={{ color: "var(--sj-text-3)" }}>{msg.length}/300 · up to 3 texts to the same person a day</p>
          <DialogFooter>
            <button type="button" data-testid="cell-text-cancel" onClick={() => setOpen(false)} className="rounded-full px-5 py-2.5 border font-medium" style={{ borderColor: "var(--sj-border)", color: "var(--sj-text-2)" }}>Cancel</button>
            <button type="button" data-testid="cell-text-send" disabled={busy} onClick={send} className="rounded-full px-6 py-2.5 text-white font-semibold disabled:opacity-60" style={{ background: "var(--sj-primary)" }}>{busy ? "Sending…" : "Send text"}</button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
